import React from 'react';

import Badge from './styled/Badge';
import Wrap from './styled/Wrap';
import { PersonReferenceBadgeProps } from './types';

const PersonReferenceBadge: React.FC<PersonReferenceBadgeProps> = props => (
  <Wrap>
    <Badge>
      <img src={props.pic} alt="" />

      <div>
        <strong>{props.name}</strong>
        {props.job}
      </div>
    </Badge>

    <img src={props.logo} alt="" />
  </Wrap>
);

export default PersonReferenceBadge;
